import { CriminalRecordCheckDocument } from '@models';

export interface CriminalRecordCheckState {
  criminalRecordCheckDocument: CriminalRecordCheckDocument | null;
  fetchedAt: Date | null;
}

export const initialCriminalRecordCheckState: CriminalRecordCheckState = {
  criminalRecordCheckDocument: null,
  fetchedAt: null,
};
